import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { LoadingOverlayWrapper } from 'components';
import { browserHistory, Link, RouteComponentProps } from 'react-router';
import { PortalPageSection } from 'components/PortalStructure';
import renderIcon from 'helpers/renderIcon';
import { readURLSearchParams } from 'helpers/common';

interface IParams {
	shopId: string;
	officeId: string;
}

interface IRouterParams {}

type IRouterProps = RouteComponentProps<IParams, IRouterParams>;

interface IProps extends IRouterProps {
	// function props
	t: any;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopBundlesServicesAddEdit extends React.Component<IProps> {
	constructor(props: IProps) {
		super(props);
	}

	render() {
		const { t } = this.props;
		const { shopId, officeId } = this.props.params;

		let serviceLink = `/shop/${shopId}/${officeId}/edit/services/add`;
		let bundleLink = `/shop/${shopId}/${officeId}/edit/bundle/add`;

		if (
			readURLSearchParams(c.SERVICE_CATEGORY) &&
			readURLSearchParams(c.SERVICE_GROUP) &&
			readURLSearchParams(c.SERVICE_LAST_ORDER_NUMBER)
		) {
			const urlParams = [
				readURLSearchParams(c.SERVICE_CATEGORY),
				readURLSearchParams(c.SERVICE_GROUP),
				readURLSearchParams(c.SERVICE_LAST_ORDER_NUMBER),
			];
			const urlParamsString = `?${c.SERVICE_CATEGORY}=${urlParams[0]}&${c.SERVICE_GROUP}=${urlParams[1]}&${c.SERVICE_LAST_ORDER_NUMBER}=${urlParams[2]}`;

			serviceLink = `/shop/${shopId}/${officeId}/edit/services/add${urlParamsString}`;
			bundleLink = `/shop/${shopId}/${officeId}/edit/bundle/add${urlParamsString}`;
		}

		return (
			<LoadingOverlayWrapper className="container bundlesServicesAddEditContainer">
				<div className="row justify-content-center">
					<div className="col-md-8">
						<div className="bundlesServicesAddEdit__header">
							<p className="bundlesServicesAddEdit__header__upperText">{t('User_ShopCard_Services_AddNewService')}</p>
							<div className="bundlesServicesAddEdit__header__titleContainer">
								{renderIcon('arrow_left', 18, 18, 'bundlesServicesAddEdit__header__back', () => {
									browserHistory.push(`/shop/${shopId}/${officeId}/edit/services`);
								})}
								<h1 className="bundlesServicesAddEdit__header__title">
									{t('User_ShopCard_Services_ChooseServiceType')}
								</h1>
							</div>
						</div>
						<div className="bundlesServicesAddEdit__selectionContainer">
							<Link to={serviceLink}>
								<PortalPageSection className="bundlesServicesAddEdit__selectionContainer__singleService">
									<div className="bundlesServicesAddEdit__selectionContainer__singleService__mainTextContainer">
										{renderIcon('singleService')}
										<span>{t('User_ShopCard_Services_SingleService')}</span>
									</div>
									<p className="bundlesServicesAddEdit__selectionContainer__singleService__subText">
										{t('User_ShopCard_Services_IndividuallyBookedServices')}
									</p>
								</PortalPageSection>
							</Link>
							<Link to={bundleLink}>
								<PortalPageSection className="bundlesServicesAddEdit__selectionContainer__bundle">
									<div className="bundlesServicesAddEdit__selectionContainer__bundle__mainTextContainer">
										{renderIcon('bundle')}
										<span>{t('User_ShopCard_Services_Bundle')}</span>
									</div>
									<p className="bundlesServicesAddEdit__selectionContainer__bundle__subText">
										{t('User_ShopCard_Services_MultipleServicesTogether')}
									</p>
								</PortalPageSection>
							</Link>
						</div>
					</div>
				</div>
			</LoadingOverlayWrapper>
		);
	}
}

export default ShopBundlesServicesAddEdit;
